import HeadingComponent from "../UserInterface/HeadingComponent";
import Description from "../UserInterface/Description";

const AboutHCID = () => {
  return (
    <div>
      <HeadingComponent headingText="HOME CREDIT INDONESIA" margin="14px" />
      <HeadingComponent headingText="Tentang Kami" margin="14px" />
      <Description
        margin="16px"
        width="876px"
        font="Roboto"
        text="PT Home Credit Indonesia merupakan perusahaan pembiayaan berbasis teknologi dengan jangkauan mitra toko yang luas di lebih dari 200 kota di Indonesia. Telah beroperasi sejak 2013, Home Credit kini berkembang menjadi mitra finansial terpercaya bagi jutaan pelanggan kami. Kami turut mendorong keterbukaan akses terhadap layanan keuangan yang transparan dengan proses cepat dan mampu membantu masyarakat dalam memenuhi kebutuhan mereka secara terencana termasuk mengelola keuangan dan cicilan mereka dengan baik."
      ></Description>
    </div>
  );
};

export default AboutHCID;
